import {
  useBjelinTranslations,
  useProductTranslations
} from "../../hooks/TranslationHooks";
import "./style.scss";
import {
  productIsPerSquareMeter,
  productIsPurchasable,
  productPriceUnit,
  useProductUrl
} from "../../utils/ProductUtils";
import { addVat } from "../../utils/VatUtils";
import divide from "lodash/divide";
import FormattedPrice from "../FormattedPrice";
import BjelinButton from "../BjelinButton";
import ProductPurchaseColumn from "../ProductPurchaseColumn";
import { useHistory } from "react-router";
import { useCurrentUser } from "../../functional-components/UserContext";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";

const GuideProductInfo = ({ product, large = false }) => {
  const { b2b } = useCurrentUser();
  const features = useSiteFeatures();
  const t = useBjelinTranslations();
  const tp = useProductTranslations();
  const history = useHistory();

  const { unitQuantityFactor, price = {} } = product;
  const isPerSquareMeter = productIsPerSquareMeter(unitQuantityFactor);
  const priceUnit = productPriceUnit(unitQuantityFactor);
  const {
    basePrice,
    unitPrice: unitBasePrice,
    previousBasePrice,
    currency
  } = price || {
    basePrice: null,
    unitPrice: null,
    previousBasePrice: null,
    currency: null
  };
  const previousPrice = previousBasePrice
    ? addVat(
        isPerSquareMeter
          ? divide(previousBasePrice, unitQuantityFactor)
          : previousBasePrice
      )
    : false;
  const hasPrice = features.prices() && !!basePrice;
  const hasPreviousPrice = features.prices() && !!previousPrice;
  const url = useProductUrl(product);

  //if (product) console.log("product", product);

  return large ? (
    <ProductPurchaseColumn sku={product.sku} />
  ) : (
    productIsPurchasable(product, b2b) && (
      <div className="guide-product-info">
        {!b2b && hasPrice && (
          <div className={"price"}>
            {isPerSquareMeter && !!unitBasePrice ? (
              <FormattedPrice
                price={addVat(unitBasePrice)}
                price_unit={priceUnit}
                currency={currency}
              />
            ) : (
              <FormattedPrice
                price={addVat(basePrice)}
                sales_unit={priceUnit}
                currency={currency}
              />
            )}
          </div>
        )}
        {!b2b && hasPreviousPrice && (
          <div className={"previous-unit-price"}>
            {tp("previous_unit_price")}
            <FormattedPrice price={previousPrice} currency={currency} />
          </div>
        )}
        <BjelinButton
          color="bjelin-green"
          block={false}
          lg={false}
          icon="chevron-right"
          onClick={e => {
            history.push(url);
            e.stopPropagation();
          }}
          className="info-btn"
        >
          <span className="btn-label">{t("more.info")}</span>
        </BjelinButton>
      </div>
    )
  );
};

export default GuideProductInfo;
